import { render } from "./OrderStatusView.vue?vue&type=template&id=12a1bc2e"
import script from "./OrderStatusView.vue?vue&type=script&lang=js"
export * from "./OrderStatusView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__